import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { SettingsComponent } from 'app/layout/common/settings/settings.component';
import { MatButtonModule } from '@angular/material/button';
import {MatTabsModule} from "@angular/material/tabs";
import {DebugPanelsModule} from "../../../modules/debug-panels/debug-panels.module";
import { TranslocoModule } from '@ngneat/transloco'

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,
        FuseDrawerModule,
        MatButtonModule,
        MatTabsModule,
        DebugPanelsModule,
        TranslocoModule,
    ],
    exports: [SettingsComponent]
})
export class SettingsModule
{
}
